<template>
  <div class="md-layout">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <h6 class="text-primary">Enquiry Follow Ups</h6>
      </md-card-header>

      <md-card-content>
        <template v-if="loaded">
          <EnquiryFollowUpsList
            label="Tours"
            :items="tourEnquiries"
            emptyText="tour"
          />

          <EnquiryFollowUpsList
            label="Events"
            :items="eventEnquiries"
            emptyText="event"
          />
        </template>

        <div v-else>Loading…</div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import enquiryApi from "@/services/api/enquiry";
import EnquiryFollowUpsList from "./EnquiryFollowUpsList.vue";

export default {
  name: "WidgetEnquiries",

  components: { EnquiryFollowUpsList },

  data() {
    return {
      loaded: false,
      enquiries: []
    };
  },

  computed: {
    tourEnquiries() {
      return this.filterByType("tour");
    },
    eventEnquiries() {
      return this.filterByType("event");
    }
  },

  methods: {
    filterByType(type) {
      return this.enquiries.filter(enq =>
        enq.tours?.some(tour => tour.type?.value === type)
      );
    }
  },

  created() {
    enquiryApi.getEnquiryFollowUps().then(response => {
      this.enquiries = response.data.enquiries;
      this.loaded = true;
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";

::v-deep .md-card-header h6 {
  margin: 0.5rem 0;
}
</style>
